import React from "react";

const ModalHelpLabel = ({ text, position }) => {
  return position === "left" ? (
    <td className="pr-8">
      <div className="flex items-center justify-end">
        <span>{text}</span>
        <div className="w-10 h-[1px] border border-[#2E90FA] absolute left-[168px]"></div>
      </div>
    </td>
  ) : (
    <td className="pl-8">
      <div className="flex items-center">
        <div className="w-10 h-[1px] border border-[#2E90FA] absolute right-[186px]"></div>
        <span>{text}</span>
      </div>
    </td>
  );
};

export default ModalHelpLabel;
